import selfcare from "../assets/images/selfcare.png"
import treatment from "../assets/images/treatment.png"
import symptoms from "../assets/images/symptoms.png"
import checkup from "../assets/images/checkup.png"

const services = [
    {
        image: selfcare,
        name: "Self Care",
        body: "Guidance and programs to support daily health and wellbeing."
    },
    {
        image: treatment,
        name: "Treatment",
        body: "Professional medical treatments tailored to your condition."
    },
    {
        image: symptoms,
        name: "Symptoms",
        body: "Information and self-assessment tools for common symptoms."
    },
    {
        image: checkup,
        name: "Check Up",
        body: "Routine health checks to monitor and prevent illness."
    },
]

export default services